import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    year,
    declarationTime,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    address2,
    province2,
    district2,
    phone2,
    fax2,
    email2,
    contract,
    date,
    organ1,
    organ2,
    certificate,
    timeSign,
    signer,
    fullName,
  },
} = checkout;

const validation = Yup.object().shape({
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [email2.name]: Yup.string().required(email2.errorMsg).email(email2.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [fax2.name]: Yup.string().optional(),
  [year.name]: Yup.string().required(year.errorMsg),
  [declarationTime.name]: Yup.string().required(declarationTime.errorMsg),
  [date.name]: Yup.number().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [contract.name]: Yup.string().required(contract.errorMsg),
  [organ1.name]: Yup.string().required(organ1.errorMsg),
  [organ2.name]: Yup.string().required(organ2.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [taxAgencyId.name]: Yup.string().required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().required(taxAgencyName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxpayerName.name]: Yup.string().optional(),
});

export default validation;
